module.exports = __webpack_public_path__ + "img/expostyle_1575_elephant_grey_pantone444c.8d42495d.jpg";